// Advisory Hub — engagements persistentes do comitê (spec-011-advisory-
// engagements-do-comite, US-9, [T062], `contracts/ui-components.md` +
// `design/wireframes.md` T1/T2).
//
// Arquivo NOVO (não reexportado por `Text.js`): `constants/Text.js` está
// sendo alterado por outra sessão em paralelo nesta mesma branch — mesmo
// padrão de isolamento de `Text.metricas.js`/`Text.aprendizado.js`, mas sem
// o passo final de reexport (que exigiria tocar o arquivo bloqueado).
// Declarado ao team-lead: quando `Text.js` estiver livre, o ideal é
// reexportar `ADVISORY_TEXT` de lá — hoje os dois arquivos novos
// (`view-advisory-list.vue`/`view-advisory-engagement.vue`) e o `routes.js`
// importam direto daqui.

export const ADVISORY_TEXT = {
  // T1 — lista
  tituloLista: 'Consultorias do escritório',
  // Subtítulo do header da rota (`NavBarNavigation route-header`) e da aba
  // do tab bar — mesmo papel do `subtitle` de cada entrada de
  // `aawzIntelligenceRoutes()` (`aawz-intelligence-nav-bar.vue`).
  subtituloLista:
    'Consultorias estratégicas conduzidas pelo comitê de especialistas, com recomendação e decisão do gestor',
  filtroStatusLabel: 'Status',
  filtroStatusTodos: 'Todos',
  vazioTitulo: 'Nenhuma consultoria ainda',
  vazioTexto: 'Consultorias abertas pelo comitê aparecem aqui. Peça na IA: "quero avaliar a expansão do escritório".',
  erroCarregarLista: 'Não foi possível carregar as consultorias.',
  proibidoTitulo: 'Esta área está disponível apenas para gestores do escritório.',
  retry: 'Tentar de novo',
  // A área que diverge só está disponível no DETALHE
  // (`recomendacao.dissentingAgents`) — o resumo da listagem (`EngagementResumo`,
  // `usecase_advisory_engagement_leitura.py::_para_resumo`) só traz o booleano
  // `tem_dissenso`. O wireframe T1 mostra "(People)"; sem esse dado na
  // listagem, o texto fica genérico (nunca inventa o nome da área).
  divergenciaRegistrada: 'Divergência registrada',
  // D-27 (design it.4): consultoria aberta hoje media `diasDesde === 0` —
  // sem caso próprio, "há 0 dias" aparecia justamente no momento mais comum
  // (logo depois de abrir a consultoria pelo chat).
  haDias: (dias) => {
    if (dias === 0) return 'hoje'
    return dias === 1 ? 'há 1 dia' : `há ${dias} dias`
  },
  // G-11 (QA it.2): "1 áreas" na linha da lista — mesma família de
  // pluralização de `haDias`/`TextChat.js::emAndamento`.
  areasCount: (n) => (n === 1 ? '1 área' : `${n} áreas`),
  // D-6 (design it.2): CTA textual no cartão que aguarda decisão — o
  // wireframe T1 já previa esse afordance explícito. Na `BaseTable`
  // (design-system, 11/09/2026) virou o tooltip/aria-label da ação de linha
  // quando `podeDecidir`; `abrirCta` é o mesmo ícone nas demais linhas.
  decidirCta: 'Decidir',
  abrirCta: 'Abrir consultoria',
  // Cabeçalho da `BaseTable` da lista — diferente de `tituloLista`, que já
  // é o H1 do shell da rota (D-4: não repetir a mesma frase a ~160px).
  tabelaTitulo: 'Consultorias',
  tabelaSubtitulo: 'Cada consultoria com o tema, as áreas envolvidas e o status da decisão.',
  // Selo da linha que salta (`aguardando_decisao` há mais de 7 dias).
  prioritaria: 'Prioritária',
  // Cabeçalhos das colunas da lista.
  colunaConsultoria: 'Consultoria',
  colunaTema: 'Tema',
  colunaAreas: 'Áreas',
  colunaAberta: 'Aberta',
  colunaStatus: 'Status',

  // T2 — sala
  voltar: 'Voltar',
  erroCarregarEngagement: 'Não foi possível carregar esta consultoria.',
  engagementVazio: 'Nenhuma informação disponível para esta consultoria.',
  // G-11 (QA it.2): quando o TEXTO da recomendação já É a opção escolhida
  // (ex.: `texto='B'`, `opcao='B'` — recomendação enxuta, sem prosa própria),
  // o sufixo "(Opção B)" duplicava a mesma letra duas vezes na mesma linha.
  // Comparação normalizada (trim + case-insensitive) — mesmo racional de
  // `advisory-engagement-header.vue::objetivoDuplicaTitulo` (D-5, design it.2).
  // D-32 (design it.7): o backend já nomeia a opção como "Opção X — ..."
  // (`694b5145`, real) — interpolar o prefixo de novo duplicava a palavra
  // ("(Opção Opção C — ...)"). `nomeSemPrefixo` remove um "Opção "/"Opcao "
  // inicial do NOME antes de interpolar; sem prefixo, o nome passa direto.
  recomendacaoResumo: (texto, opcao) => {
    const textoNormalizado = (texto || '').trim().toLowerCase()
    const opcaoNormalizada = (opcao || '').trim().toLowerCase()
    if (!opcao || textoNormalizado === opcaoNormalizada) return texto
    const nomeSemPrefixo = opcao.trim().replace(/^op[çc][ãa]o\s+/i, '')
    return `${texto} (Opção ${nomeSemPrefixo})`
  },
  // NICE 5 (review front it.7): estava hardcoded nos dois consumidores
  // (`advisory-recomendacao-resumo.vue`, `advisory-decisao-form.vue`) —
  // rótulos vizinhos já vinham de `TextAdvisory.js`.
  recomendacaoDaMesaTitulo: 'Recomendação da mesa',
  apoiam: 'Apoiam:',
  confiancaLabel: 'confiança',
  // T095 (G-4, QA it.2) — seção "Deliberação": o que cada área disse em cada
  // rodada (`advisory-opinioes-rodadas.vue`).
  deliberacaoTitulo: 'Deliberação',
  deliberacaoVazia: 'Nenhuma opinião registrada ainda.',
  rodadaTitulo: (rodada) => `Rodada ${rodada}`,
  // D-30 (design it.6) — a tabela de opções não tinha rótulo de bloco; o
  // wireframe T2 marca "▾ OPÇÕES" como uma das cinco seções da sala.
  opcoesTitulo: 'Opções',
  // G-27 (QA it.6) — o plano de ação gravado na decisão (`decisao.actionPlan`,
  // `advisory-shapes.js`) não aparecia em lugar nenhum da sala decidida.
  planoDeAcaoTitulo: 'Plano de ação',
  // F-3 (review front spec-015 it.1) — `HEADERS` de `advisory-plano-acao.vue`
  // escrevia as 4 colunas inline; as 3 chaves abaixo tinham ZERO
  // consumidores desde este mesmo commit. `planoDeAcaoAcao` fecha o
  // conjunto (faltava a coluna "Ação") e o componente passou a montar
  // `HEADERS` a partir destas 4 chaves — texto e rótulo nunca mais
  // divergem.
  planoDeAcaoAcao: 'Ação',
  planoDeAcaoResponsavel: 'Responsável sugerido',
  planoDeAcaoPrazo: 'Prazo',
  planoDeAcaoMetrica: 'Métrica',
  // G-28 (QA it.6) — recomendação vinda do caminho DETERMINÍSTICO
  // (`consolidacao_fallback=true`) publicava "0% confiança" sem dizer por
  // que — o número é real, mas o discriminante que o explica não chegava à
  // tela. Substitui o selo de percentual, no MESMO lugar (nunca os dois
  // juntos: o percentual daquele caminho é sempre 0,000 e não tem leitura
  // própria).
  consolidacaoFallbackAviso: 'Síntese determinística, sem grau de confiança do modelo',
  // Só as 3 status ANÔMALAS levam selo — `ok` é o caminho normal (a fala já
  // diz que a área respondeu) e um selo "Analisou" em toda opinião normal
  // seria ruído (mesmo racional de `TextChat.js::ESTADO_AREA_LABEL`, que só
  // rotula o desvio). Enum real: `core/painel/envelope.py::STATUS`.
  opiniaoStatusLabel: {
    indisponivel: 'Indisponível',
    timeout: 'Não respondeu a tempo',
    fora_de_escopo: 'Fora do escopo',
  },
  opiniaoConfiancaLabel: {
    alta: 'Confiança alta',
    media: 'Confiança média',
    baixa: 'Confiança baixa',
  },
  decisaoRegistrarTitulo: 'Registrar decisão',
  decisaoCancelar: 'Cancelar',
  // T092b — o modal passou a possuir `v-slot:actions` (antes eram botões
  // internos de `advisory-decisao-form.vue`); rótulos centralizados aqui,
  // como o restante do módulo, em vez de const local no `.vue`.
  decisaoPreVisualizar: 'Pré-visualizar',
  decisaoVoltarPasso: 'Voltar',
  decisaoConfirmar: 'Confirmar decisão',
  decisaoFechar: 'Fechar',
  erroDecidir: 'Não foi possível registrar a decisão. Tente novamente mais tarde.',
  erroPreVisualizar: 'Não foi possível pré-visualizar a decisão. Tente novamente mais tarde.',
  // G-5 (QA it.2): faixa "Decidido em DD/MM/AAAA [· reavaliar em DD/MM/AAAA]"
  // na sala de um engagement já decidido — `dataReavaliar` só existe para
  // `accepted_with_changes`/`deferred` (`ATOS_QUE_HABILITAM_REAVALIAR` do
  // form), por isso o trecho é OPCIONAL, nunca "· reavaliar em -".
  decididoFaixa: (dataDecisao, dataReavaliar) => {
    const base = `Decidido em ${dataDecisao}`
    return dataReavaliar ? `${base} · reavaliar em ${dataReavaliar}` : base
  },
  // T118 (achado R-1 do T117) — quando `decisao.opcaoEscolhida` diverge de
  // `recomendacao.opcaoEscolhida`, a faixa nomeia as DUAS escolhas (a do
  // gestor e a que a mesa recomendou). Só chamada quando as duas divergem
  // (`view-advisory-engagement.vue::divergeDaEscolha`) — quando coincidem, o
  // selo único na tabela de opções já basta, sem repetir o texto aqui.
  decisaoEscolhaDivergente: (escolhaGestor, recomendacaoIa) =>
    `Gestor escolheu «${escolhaGestor}» (IA recomendou «${recomendacaoIa}»)`,
  // G-5 — sem rota de deep-link por item no módulo `conhecimento` (só a
  // lista geral, `aawz-intelligence.conhecimento`, existe): o rótulo fica
  // como TEXTO (não link), com o id completo exposto via atributo `title`
  // (tooltip nativo) — nunca a UUID crua no corpo do texto.
  conhecimentoOficialLink: 'Conhecimento oficial',
  // "Promover novamente" (UC-7 exemplo 3, [T058b]/[T062b]) — retry SÓ da
  // promoção, pela MESMA rota de `decidir` com corpo alternativo
  // (`apiAdvisory.promoverNovamente`). Fallbacks para quando o corpo do
  // envelope não traz `message` (a régua real é `r.message`, sempre
  // preferida — ver `view-advisory-engagement.vue::onPromoverNovamente`).
  promoverNovamenteJaPromovida: 'Esta decisão já foi promovida a conhecimento oficial.',
  erroPromoverNovamente: 'Não foi possível promover novamente. Tente novamente mais tarde ou contate o suporte.',

  // SSE
  sseErro: 'O acompanhamento desta consultoria foi interrompido. Recarregue a página.',

  // S-2 (design/QA review) — a célula ANTES do diff de promoção vem `null`
  // quando `ativo is None` no backend (`_montar_diff_knowledge`,
  // `usecase_advisory_decisao.py`) — ou seja, é a PRIMEIRA decisão do
  // engagement a virar conhecimento oficial, não um campo vazio. Legenda
  // exibida no lugar da célula em branco (`advisory-decisao-form.vue`).
  decisaoDiffNovoItem: 'novo item',
}

// D-3 (design it.2, `contracts/ui-components.md` §5): o formulário de
// decisão (two-step: passo 1 + preview) vive num `BaseModal` dedicado,
// aberto via `GlobalBus`. Canal PRÓPRIO — nunca o objeto `MODAL` de
// `constants/Text.js` (bloqueado por outra sessão, mesmo racional do
// `ADVISORY_TEXT` acima).
export const MODAL_ADVISORY = {
  DECISAO: 'modal_advisory_decisao',
}

// T092b — os 6 valores de `step` emitidos por `advisory-decisao-form.vue`
// via `@step-change` (computed `step`) e consumidos por
// `advisory-decisao-modal.vue` (`stepAtual`) para escolher o rótulo/handler
// do botão primário. Antes redigitados como string em cada `if`/`return` dos
// dois arquivos — comentário do reviewer humano do PR #2117
// (HerikR0drigues). Os VALORES não mudam (contratos de teste/E2E dependem
// deles) — só o ponto único de declaração.
export const ADVISORY_DECISAO_STEPS = Object.freeze({
  CARREGANDO: 'carregando',
  VAZIO: 'vazio',
  ERRO: 'erro',
  PASSO_1: 'passo1',
  PREVIEW: 'preview',
  RESULTADO: 'resultado',
})

// Os 5 valores de `status` (`data-model.md` §2.1,
// `ck_intelligence_v2_advisory_eng_status`) — fonte ÚNICA de rótulo/cor,
// consumida pela lista, pela sala e pelo `advisory-engagement-header.vue`.
export const ADVISORY_STATUS_LABELS = {
  ativo: 'Em andamento',
  aguardando_decisao: 'Aguardando decisão',
  decidido: 'Decidido',
  encerrado: 'Encerrado',
  arquivado: 'Arquivado',
}

export const ADVISORY_STATUS_COLORS = {
  ativo: 'primary',
  aguardando_decisao: 'warning',
  decidido: 'success',
  encerrado: 'secondary',
  arquivado: 'dark',
}

// T095 — cor do selo de status ANÔMALO de uma opinião (`ok` nunca leva selo,
// ver `opiniaoStatusLabel`).
export const ADVISORY_OPINIAO_STATUS_COLORS = {
  indisponivel: 'secondary',
  timeout: 'warning',
  fora_de_escopo: 'secondary',
}

// T095 — cor do chip de severidade de uma contribuição (`contracts/api.yaml`
// `Contribuicao.severidade`, enum `bloqueante|atencao|informativo`). Mesma
// hierarquia de peso visual de `painel-deliberacao-view.js::COR_POR_CLASSE`
// ("uma restrição bloqueante não pode ter o mesmo peso visual de um alerta").
export const ADVISORY_SEVERIDADE_COLORS = {
  bloqueante: 'danger',
  atencao: 'warning',
  informativo: 'secondary',
}

// T095 — rótulo PT-BR de `Contribuicao.classe` (`contracts/api.yaml`, enum
// `proposta|restricao|dependencia|alerta|alerta_obrigatorio`, medido no
// envelope real — `envelope->'contribuicoes'` de
// `aawz_intelligence_v2_advisory_opinions`). Classe fora do mapa (schema novo
// à frente do front) cai no valor CRU — mesmo racional de `labelDoAdvisor`/
// `constants/Fontes.js`: esconder o não-mapeado faria a contribuição
// desaparecer da tela, e "sem esses dados, confiança nasce baixa" (dado real
// do engagement `65d50afb`) é informação que não pode sumir.
// Nomes PT-BR dos 9 advisors do Advisory Hub (D-16, design it.3) — os
// mesmos 9 slugs de `especialistas.py::MESAS_POR_DECISAO_ADVISORS` +
// `COAUTORIA_ADVISORS` (backend), mapeados pelo comentário de domínio
// daquele arquivo (ESTRATEGIA/M&A, FINANCEIRO/TRIBUTARIO, JURIDICO,
// TECNOLOGIA, COMERCIAL, MARCA, PESSOAS). Fonte ÚNICA — `labelDoAdvisor`
// (`views/advisory/advisory-shapes.js`) consulta este mapa antes do
// fallback de humanização do slug; slug fora do mapa continua caindo no
// fallback (nunca esconder um advisor desconhecido).
export const ADVISORY_ADVISOR_LABELS = {
  'strategy-advisor': 'Estratégia',
  'ma-advisor': 'M&A',
  'finance-advisor': 'Financeiro',
  'accounting-advisor': 'Contábil',
  'legal-advisor': 'Jurídico',
  'technology-advisor': 'Tecnologia',
  'commercial-advisor': 'Comercial',
  'marketing-advisor': 'Marca',
  'people-advisor': 'Pessoas',
}

export const ADVISORY_CONTRIBUICAO_CLASSE_LABELS = {
  proposta: 'Proposta',
  restricao: 'Restrição',
  dependencia: 'Dependência',
  alerta: 'Alerta',
  alerta_obrigatorio: 'Alerta obrigatório',
}

// Agrupamento da T1 (`design/wireframes.md` T1: "AGUARDANDO DECISÃO" /
// "EM ANÁLISE" / "DECIDIDAS") — rótulo de SEÇÃO, diferente do rótulo do
// `BaseStatus` de cada linha (`ADVISORY_STATUS_LABELS` acima). `encerrado`/
// `arquivado` não estão no wireframe; caem no grupo "Encerradas" (criado
// aqui para não desaparecerem da lista).
export const ADVISORY_GRUPOS_POR_STATUS = {
  aguardando_decisao: 'AGUARDANDO DECISÃO',
  ativo: 'EM ANÁLISE',
  decidido: 'DECIDIDAS',
  encerrado: 'ENCERRADAS',
  arquivado: 'ARQUIVADAS',
}

// Os 13 temas (`spec.md:80`, `constants/advisory.py::ENGAGEMENT_TYPES`) —
// fonte ÚNICA, mesmo racional do mapa de status acima.
// S-2 (design/QA review) — o preview de promoção a conhecimento oficial
// (`PreviewDecisao.diff[]`, `_montar_diff_knowledge` em
// `usecase_advisory_decisao.py:191-217`) manda a CHAVE CRUA do payload em
// `campo` (`payload.regra`, `payload.itens`, `name`) — vocabulário de
// implementação, não rótulo para o gestor ler. `labelDoCampoDiff`
// (`views/advisory/advisory-shapes.js`) consulta este mapa antes do
// fallback de humanização (mesmo padrão de `ADVISORY_ADVISOR_LABELS`/
// `labelDoAdvisor`) — o conjunto de chaves reais é fechado (só `regra`/
// `itens` dentro de `payload.*`, mais `name`), mas o fallback cobre um
// `payload.<chave>` novo sem esconder o campo.
export const ADVISORY_KNOWLEDGE_CAMPO_LABELS = {
  name: 'Nome',
  'payload.regra': 'Regra',
  'payload.itens': 'Itens',
}

export const ADVISORY_TYPE_LABELS = {
  plano_expansao: 'Plano de expansão',
  crescimento_ou_ma: 'Crescimento ou M&A',
  estrutura_organizacional: 'Estrutura organizacional',
  partnership: 'Partnership',
  pessoas: 'Pessoas',
  juridico_societario: 'Jurídico societário',
  comercial: 'Comercial',
  marketing: 'Marketing',
  tecnologia: 'Tecnologia',
  sucessao: 'Sucessão',
  valuation: 'Valuation',
  eficiencia_operacional: 'Eficiência operacional',
  outro: 'Outro',
}
